import {
  CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';

import { surfacesPlugin } from '../plugin';

export const SurfaceCollectionEntryExtension = surfacesPlugin.provide(
  createCollectionEntryExtension({
    id: 'surface',
    resourceType: 'Surface',
    predicate: ({ resource }: CollectionEntryOptions) =>
      '__typename' in resource && resource.__typename === 'WorkflowV1Surface',
    render: () => null,
  }),
);
